export default "__VITE_ASSET__47c21b73__"